export const handleAspects = ({ aspectsAttributes, aspects, ev }) => {
    for (const { aspectName, params } of aspectsAttributes) {
        aspects[aspectName ?? '']?.(ev, params);
    }
};
//# sourceMappingURL=handleAspects.js.map